import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=b93ae790&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=js&"
export * from "./tongji.vue?vue&type=script&lang=js&"
import style0 from "./tongji.vue?vue&type=style&index=0&id=b93ae790&prod&lang=scss&"
import style1 from "./tongji.vue?vue&type=style&index=1&id=b93ae790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93ae790",
  null
  
)

export default component.exports